/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_b1440821{background:blue}\n"}]);
export const dummy = "dummy_b1440821";